import { AppAnalytics, ErrorMsg } from '../../Analytics';
import { PAGE_NAME } from '../../eventNames';

const errorMsgEvents = {
  userAction: (pageName, eventContext = {}) => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(
      new ErrorMsg(pageName || PAGE_NAME.REPORT_LIST_VIEW, 'User Action', context)
    );
  },

  apiError: (eventContext = {}, pageName) => {
    const context = { ...eventContext };
    AppAnalytics.reportEvent(
      new ErrorMsg(pageName || PAGE_NAME.REPORT_LIST_VIEW, 'API Error', context)
    );
  },
};

export default errorMsgEvents;
